import CusDrawer from 'components/CusDrawer';
import CusModal from 'components/CusModal';
import useMain from 'hooks/useMain';
import { SidebarForm } from 'pages/module/component';
import { userEditFields } from 'pages/userAdmin/user-fields';
import React, { useEffect, useMemo, useState } from 'react';
import { micService } from 'services/mic';
import { setState } from 'store/reducers/comModule';
import { handleAsyncCall } from 'utils/common';
import { ProjRoleSelector } from './projRoleSelector';

export const UserAdminSidebar = ({ openSiderbar, setOpenSidebar, handleSubmit, selectedRow }) => {
  const { t, useNavigate, useLocation, dispatch, useSelector, project, upperCaseLang } = useMain();
  const [companies, setCompanies] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const userProjsRoles = useSelector((s) => s.comModule.userProjsRoles);
  const companyOptions = companies.map((c) => ({
    label: (c?.ProjCode ? ` ${c?.ProjCode} - ` : '') + c[`Name${upperCaseLang}`] + (c?.RefCode ? ` (${c?.RefCode})` : ''),
    value: c.Id
  }));

  const isNew = useMemo(() => selectedRow?.UserName && !selectedRow?.UserId, [selectedRow?.UserName, selectedRow?.UserId]);

  useEffect(() => {
    if (openSiderbar) {
      handleAsyncCall({
        service: micService.getCompanies,
        params: {
          id: '99999999-9999-9999-9999-999999999999'
        },
        successCb: (res) => {
          setCompanies(res.data);
        }
      });
    }
  }, [openSiderbar]);
  useEffect(() => {
    if (openSiderbar && isNew) {
      dispatch(setState(['userProjsRoles', []]));
    }
  }, [openSiderbar, isNew]);
  const onAddPermission = () => {
    setOpenModal(true);
  };

  const onDelete = (row) => {
    const filteredList = userProjsRoles.filter((v) => v !== row);
    dispatch(setState(['userProjsRoles', filteredList]));
  };
  return (
    <CusDrawer open={openSiderbar} onClose={() => setOpenSidebar(false)}>
      <SidebarForm
        formData={selectedRow}
        title={isNew ? t('BTN_ADD') : t('EDIT')}
        buttonLabel={t('SUBMIT')}
        handleSubmit={handleSubmit}
        fields={userEditFields({
          t,
          companyOptions,
          upperCaseLang,
          isNew,
          onAddPermission,
          userProjsRoles,
          onDelete
        })}
      />
      <CusModal
        open={openModal}
        setOpen={setOpenModal}
        content={<ProjRoleSelector userId={selectedRow?.UserId || selectedRow?.Id} setOpenModal={setOpenModal} />}
      />
    </CusDrawer>
  );
};
